export const userRolesMap = {
  pgUser: 'PG-Users',
  pgSystemAdmin: 'PG-System-Admin',
};
